import { FC, ReactNode, useEffect, useState } from 'react';
import Slider, { Settings } from 'react-slick';

import { Arrow } from './Arrow/Arrow.component';

import 'slick-carousel/slick/slick.css';
import './Carousel.component.scss';

export interface Props {
  settings?: Settings;
  content: ReactNode[];
}

export const Carousel: FC<Props> = ({ settings, content }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const componentSettings: Settings = {
    autoplay: false,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: function (index) {
      // eslint-disable-next-line
      return <a className={'slider-paging'}>{index + 1}</a>;
    },
    dotsClass: 'slick-dots slick-thumb',
    nextArrow: currentSlide === content.length - 1 ? <></> : <Arrow direction='right' />,
    prevArrow: currentSlide === 0 ? <></> : <Arrow direction='left' />,
    afterChange: (currSlide) => setCurrentSlide(currSlide),
    ...settings,
  };

  return (
    <div className={'carousel-container'}>
      <Slider {...componentSettings}>{content}</Slider>
    </div>
  );
};
